import React from 'react';
import {FilterList} from '@material-ui/icons';

export function FilterListIcon() {
  return <FilterList color="primary" />;
}
